import { useEffect, useState } from "react";

// Hook to handle the state of the checkboxes for a list of data.
// - data: An array of elements with an id field.
// - isElementDisabled: A function that returns whether or not the given element
// must be disabled.
function useCheckboxes(data: any, isElementDisabled: any) {
  const [checkboxesState, updateCheckboxesState] = useState<any>({
    itemsStatus: {},
    allChecked: false,
  });

  // Initialize the state for all the checkboxes.
  useEffect(() => {
    updateCheckboxesState(() => {
      const itemsStatus = {};
      let allDisabled = true;
      let allChecked = true;
      for (const element of data) {
        allDisabled = allDisabled && isElementDisabled(element);
        itemsStatus[element.id] = {
          element: element,
          checked: element.initialCheckedStatus || false,
          disabled: isElementDisabled(element),
        };
        allChecked = allChecked && (element.initialCheckedStatus || false);
      }
      return {
        itemsStatus: itemsStatus,
        allChecked: allChecked,
        allDisabled: allDisabled,
      };
    });

    // eslint-disable-next-line
  }, [data]);

  const mainCheckboxOnChange = (e: any) => {
    const itemsStatus = {};
    let atLeastOneChecked: any = false;
    let allDisabled: any = true;
    for (const element of data) {
      const isDisabled = isElementDisabled(element);
      allDisabled = allDisabled && isDisabled;
      const checked = isDisabled ? false : e.target.checked;
      atLeastOneChecked |= checked;
      itemsStatus[element.id] = {
        element: element,
        checked: checked,
        disabled: isDisabled,
      };
    }
    const allChecked = e.target.checked && atLeastOneChecked;
    updateCheckboxesState({
      itemsStatus: itemsStatus,
      allChecked: allChecked,
      allDisabled: allDisabled,
    });
  };

  const secondaryCheckboxOnChange = (id: any, e: any) => {
    updateCheckboxesState((oldCheckboxesState) => {
      const itemsStatus = { ...oldCheckboxesState.itemsStatus };
      if (itemsStatus[id].disabled) return;
      itemsStatus[id].checked = e.target.checked;
      let allChecked: any = true;
      let atLeastOneChecked: any = false;
      let allDisabled = true;
      for (const element of data) {
        const isDisabled = isElementDisabled(element);
        allDisabled = allDisabled && isDisabled;

        allChecked =
          allChecked && (itemsStatus[element.id].checked || isDisabled);
        atLeastOneChecked |= itemsStatus[element.id].checked;
      }
      allChecked &= atLeastOneChecked;
      return {
        itemsStatus: itemsStatus,
        allChecked: allChecked,
        allDisabled: allDisabled,
      };
    });
  };

  return [checkboxesState, mainCheckboxOnChange, secondaryCheckboxOnChange];
}

export default useCheckboxes;
